import { franc } from 'franc-min';
import FJDomUtil from './FJDomUtil';

const FJStringUtil = {
    isEnglish: function (str) {
        return this.getStringLanguage(str) === 'eng';
    },
    /**
     * @description 获取文件名
     * @param path
     * @param deleteExt
     * @returns {string}
     */
    getFileName: function (path, deleteExt) {
        if (!path) return '';
        let name = path.substr(path.lastIndexOf('/') + 1);
        if (deleteExt) name = name.split('.')[0];
        return name;
    },
    getStringLanguage: function (str) {
        return franc(str);
    },

    getFileSuffix: function (name) {
        return name.split('.').pop();
    },

    getUseFileName: function (name, suffix) {
        const now = new Date();
        // 获取年、月、日、时、分、秒
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1并补零
        const day = String(now.getDate()).padStart(2, '0'); // 补零
        const hours = String(now.getHours()).padStart(2, '0'); // 补零
        const minutes = String(now.getMinutes()).padStart(2, '0'); // 补零
        const seconds = String(now.getSeconds()).padStart(2, '0'); // 补零

        const px = name ? name + '-' : '';
        // 格式化日期和时间为 2024-07-17T111525
        return `${px}Made with FlexClip AI-${year}-${month}-${day}T${hours}${minutes}${seconds}${suffix}`;
    },

    getByteLen: function (str) {
        // return encodeURIComponent(str).replace(/%[A-F\d]{2}/g, 'U').length;
        let len = 0;
        for (let i = 0; i < str.length; i++) {
            str.charCodeAt(i) < 256 ? (len += 1) : (len += 2);
        }
        return len;
    },

    sliceByteLen: function (str, num) {
        if (!str || num <= 0) return '';

        let result = '';
        let asciiCount = 0;

        // 使用扩展运算符将字符串分解为字符数组
        for (const char of [...str]) {
            // 获取字符的 ASCII 值长度
            const charCode = char.charCodeAt(0);
            // ASCII 字符（0-127）计数为1，其他字符计数为2
            const charLength = charCode < 256 ? 1 : 2;

            // 检查是否超出限制
            if (asciiCount + charLength > num) {
                break;
            }

            result += char;
            asciiCount += charLength;
        }

        return result;
    },

    getPathSuffix: function (path) {
        return path.substr(path.lastIndexOf('.') + 1).trim();
    },

    getEspText: function (name, fontSize, maxWidth) {
        if (!name || typeof name !== 'string') {
            return '';
        }
        let fileText;
        let fileExt = FJStringUtil.getPathSuffix(name);

        if (fileExt.length === 0 || fileExt.length >= 5) {
            return {
                fileTextType: 'NO EXT',
                fileName: name,
                fileText: name,
            };
        }

        const fontInfo = {
            fontFamily: 'Roboto',
            fontSize,
        };
        const fileName = name.replace('.' + fileExt, '');
        const extWidth = fileExt ? FJDomUtil.calcTextSize(fileExt, fontInfo).width : 0; // 后缀的宽度
        const nameWidth = FJDomUtil.calcTextSize(name, fontInfo).width; // 完整那么的宽度
        const lastChar = fileExt === '' ? fileName.slice(fileName.length - 4) : fileName[fileName.length - 1];
        const lastCharWidth = FJDomUtil.calcTextSize(lastChar, fontInfo).width;

        // 所能容纳下的最大宽度
        const filePureNameMaxWidth = maxWidth - extWidth - lastCharWidth;

        if (maxWidth > 0 && nameWidth > 0 && nameWidth >= maxWidth) {
            const ratio = filePureNameMaxWidth / nameWidth;
            let index = Math.floor(fileName.length * ratio);
            let text = fileName.slice(0, index);
            let textWidth = FJDomUtil.calcTextSize(text, fontInfo).width;

            if (textWidth > filePureNameMaxWidth) {
                index--;
                while (textWidth < filePureNameMaxWidth && index > 10) {
                    text = fileName.slice(0, index);
                    textWidth = FJDomUtil.calcTextSize(text, fontInfo).width;
                    index--;
                }
            } else if (textWidth < filePureNameMaxWidth) {
                index++;
                let oldText = text;
                while (textWidth > filePureNameMaxWidth) {
                    oldText = text;
                    text = fileName.slice(0, index);
                    textWidth = FJDomUtil.calcTextSize(text, fontInfo).width;
                    if (textWidth === 0) {
                        textWidth = 99999;
                    }
                    index++;
                }
                text = oldText;
            }
            fileText = text + '...' + lastChar + '.' + fileExt;
        } else {
            fileText = name;
        }

        return {
            fileTextType: 'HAS EXT',
            fileName: fileName,
            fileText: fileText,
        };
    },
    removePunctuation: function (str) {
        // 使用正则表达式匹配所有标点符号并替换为空字符串
        return str.replace(/[^\w\s]/g, '');
    },
};
export default FJStringUtil;
